import './App.css';
import DayLifeTravels from './DayLifeTravels';

function App() {
  return (
    <div className="App">
      <DayLifeTravels />
    </div>
  );
}

export default App;
